import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { TransportersOverview } from './overview';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class TransportersPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <Switch>
          {/* <Route
            path="(.*)/transport-orders/:id(.*)"
            render={component => <TransportOrderDetails transportOrderId={parseInt(component.match.params.id, 10)} />}
          /> */}
          <Route component={TransportersOverview} />
        </Switch>
      </Container>
    );
  }
}

TransportersPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportersPage = compose(withConnect, withRouter)(TransportersPageComp);
